import React, { Component } from 'react';
// import { NavLink } from 'react-router-dom';
import Navbar from './components/Navbar';
import Event from './components/Event';

class Schedule extends Component {
    componentDidMount() {
        const { handleInfoData } = this.props;
        handleInfoData('schedule');
        this.props.handleUserData();
    }

    createEvents = (events, role) => {
        console.log(events);
        console.log(role);
        const eventList = [];
        for(let i = 0; i < events.length; i++) {
            if(role === "guest" && (events[i].userAccess === "all" || events[i].userAccess === "guest")) {
                eventList.push(<Event name={events[i].name} description={events[i].description} time={events[i].time} key={i}/>);
            } else if(role === "weddingparty" && (events[i].userAccess === "all" || events[i].userAccess === "wedding party")) {
                eventList.push(<Event name={events[i].name} description={events[i].description} time={events[i].time} key={i}/>);
            } else if(role === "admin") {
                eventList.push(<Event name={events[i].name} description={events[i].description} time={events[i].time} key={i}/>);
            }
        }
        return(eventList);
    }

    render() {
        const { scheduleData, userData } = this.props;
        return (
            <div className="App">
                <Navbar/>
                <h1 className="App-section-title">Schedule</h1>
                <div className="App-details">
                    <p className="App-details-title">{scheduleData.schedule.date}</p>
                    <a href={scheduleData.schedule.addressURL} target="_blank" rel="noopener noreferrer">📍 {scheduleData.schedule.address}</a>
                    {/* <NavLink to="/map" target="_blank" rel="noopener noreferrer"><p>Map of Mansion</p></NavLink> */}
                    <hr className="Border-solid"/>
                </div>
                <div className="App-table-container">
                    {scheduleData.events.length > 0 && userData.role !== "" && userData.role !== undefined && this.createEvents(scheduleData.events, userData.role)}
                </div>
            </div>
        )
    }
}

export default Schedule;